<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 顶部标题 -->
            <div class="pdfPageTitle mg_t">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first">间接减排贡献</span>
                    <span class="pdfPageTitle-txt__second">(权重{{PdftStore.fromData.spaceEmissionIndirectReduction?.weight}}%)</span>
                </div>
                <!-- <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page8.png">
                </div> -->
            </div>

            <!-- 顶部数据 -->
            <div class="top_box">
                <div class="left">
                    <div class="title mg_b">间接减排量：</div>
                    <div class="txt">{{PdftStore.fromData.spaceEmissionIndirectReduction?.emissionDataStr}}</div>
                    <!-- <div class="tx">数据来源：XXX报告PXX页。</div> -->
                </div>
                <div class="right">
                    <div class="title">数据与参考标准</div>
                    <div class="txt">{{PdftStore.fromData.spaceEmissionIndirectReduction?.referenceStandards}}</div>
                </div>
            </div>

            <!-- 明细 -->
            <div class="min_box">
                <div class="title">碳中和进程评级得分明细</div>
                <List :type=4  :id="'listPdfReport4'"/>
            </div>

            <!-- 数据图表 -->
            <div class="banner_box">
                <div class="left_box">
                    <div class="title">间接减排得分：</div>
                    <div class="jindu" v-if="PdftStore.fromData.spaceEmissionIndirectReduction">
                        <NewPro
                            :name="'page8progess'"
                            :centerNum="1"
                            :minScore="0"
                            :centerScore="70"
                            :leftScore="PdftStore.fromData.spaceEmissionIndirectReduction?.emissionReductionScore"
                            :maxEmiss="'无减排'"
                            :minEmiss="'高减排'"
                            :maxScore="100"
                            :rightMinScore="0"
                            :rightMaxScore="30"
                            :rightScore="PdftStore.fromData.spaceEmissionIndirectReduction?.emissionReductionMeasuresScore"
                            :rightMinTxt="'无减排措施'"
                            :rightMaxTxt="'多项减排措施'"
                            />
                    </div>
                </div>
                <div class="right_box">
                    <div class="top_box_banner">
                        <div class="title">评分逻辑</div>
                        <div class="txt">{{PdftStore.fromData.spaceEmissionIndirectReduction?.scoreStandard}}</div>
                    </div>
                    <div class="title">碳中和进程评级综合表现</div>
                    <div class="ec_t">
                        <Echarts v-if="PdftStore.fromData.spaceEmissionIndirectReduction" :name="'page8echarts'" :type="'d'"/>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">06</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import List from '../components/list.vue'
import NewPro from '../components/newPro.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page8',
    components:{Headers, Bottoms, List, NewPro, Echarts},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .mg_t{
            margin-top: 96px;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .top_box{
            margin-top: 50px;
            display: flex;
            justify-content: stretch;
            .title{
                font-size: 28px;
                font-weight: bold;
                color: #333333;
                line-height: 42px;
            }
            .left{
                width: 670px;
                padding-right: 40px;
                border-right: 1px dashed #C5C5C6;
                flex: 1;
                .mg_b{
                    margin-bottom: 20px;
                }
                .txt{
                    font-size: 32px;
                    font-weight: 500;
                    line-height: 36px;
                    color: rgba(0, 186, 244, 1);
                }
                .tx{
                    margin-top: 15px;
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .right{
                width: calc(100% - 670px);
                padding-left: 40px;
                flex: 1;
                .txt{
                    font-size: 16px;
                    font-weight: 400;
                    color: #333333;
                    text-align: justify;
                    line-height: 24px;
                    margin-top: 23px;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            
        }
        .min_box{
            margin-top: 55px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            .title{
                margin-bottom: 33px;
                font-weight: bold;
            }
        }
    }
}
.banner_box{
    display: flex;
    width: 100%;
    height: 900px;
    margin-top: 30px;
    justify-content: stretch;
    .left_box{
        width: 670px;
        padding-right: 40px;
        border-right: 1px dashed #C5C5C6;
        flex: 1;
    }
    .right_box{
        width: calc(100% - 670px);
        flex: 1;
        padding-left: 40px;
    }
    .top_box_banner{
        height: 350px;
    }
    .title{
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        line-height: 42px;
    }
    .jindu{
        width: 100%;
        margin-top: 50px;
    }
    .mg_top{
        margin-top: 90px;
    }
    .ec_t{
        margin-top: 10px;
        width: 100%;
        height: 413px;
    }
    .txt{
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        text-align: justify;
        line-height: 24px;
        margin-top: 10px;
        white-space: normal;
        word-wrap: break-word;
    }
    .txt_s{
        color: #999999;
    }
}
</style>